export default __webpack_public_path__ + "static/media/lightSwapCard.05feec8a.png";